import React, { Component } from 'react';

import Router from './Routes';
import './App.css';

class App extends Component {
  render() {
    return (
	    <div className="App">
	      <Router />
	    </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js